import { Utils } from "src/modules/utils/shared/utils";
import { BackendResponseItem } from "./backend-response-item.model";
import { BackendResponseStatus } from "./backend-response-status.enum";

export class BackendResponse extends Error {

    isBackendResponse = "a1be17bef39cf8e3";

    static error(message: string, errorId = 0, recoverable = true): BackendResponse {
        return new BackendResponse([new BackendResponseItem(BackendResponseStatus.error, message, errorId, recoverable)]);
    }

    static success(message: string, errorId = 0): BackendResponse {
        return new BackendResponse([new BackendResponseItem(BackendResponseStatus.success, message, errorId)]);
    }

    static getFromException(ex: any): BackendResponse {
        if ("response" in ex) {
            ex = ex.response;
        }
        if ("error" in ex && "status" in ex) {
            let ex2 = Utils.fromJson(Utils.toString(ex.error));
            if (ex2.isBackendResponse == "a1be17bef39cf8e3") {
                ex = ex2;
            }
        }
        return ex instanceof BackendResponse ? ex : ex.isBackendResponse == "a1be17bef39cf8e3" ? Utils.fromPlainUnsafe(BackendResponse, ex) : "message" in ex ? BackendResponse.error(ex.message) : null;
    }

    constructor(public items: BackendResponseItem[]) {
        super("");
        this.name = "BackendResponse";
    }

    getMessage(): string {
        return Utils.arrayItemsToString(this.items, "\n", item => item.message);
    }

    isErrorId(id: number): boolean {
        return this.items.some(bri => bri.errorId == id);
    }
}
